export const profileData = {
  name: "Golam Sarwar",
  title: "Full Stack Developer",
  email: "ssarwar459@gmail.com",
  phone: "+8801998787793",
  github: "https://github.com/Sarwar009",
  linkedin: "https://www.linkedin.com/in/sarwar009/",
  image: "/dp.jpeg",
};
